import React from "react";
import { Col, Row, Button } from "reactstrap";

import withRouter from "../../Components/Common/withRouter";

const PSGP = () => {
  document.title = "PSGP | Business Online";
  return (
    <React.Fragment>
      <Row className="g-0 auth-container">
        <Col lg={12} xs={12}>
          <div className="faq-bloc">
            <div>
              <h2 style={{ textAlign: "center" }}>P.S.G.P</h2>
            </div>
            <div className="mt-4">
              <Button
                color="success"
                className="w-100"
                type="submit"
                onClick={() => {
                  window.location.href = "/PSGP.pdf";
                }}
              >
                Cliquez ici pour consulter cette version de la PSGP
              </Button>
            </div>
          </div>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default withRouter(PSGP);
